import { createContext, createRef } from 'react';

export const SubmenuContext = createContext<{ parentMenuRef: React.RefObject<HTMLElement> }>({
    parentMenuRef: createRef(),
});
